module.exports = __webpack_public_path__ + "static/img/14002018.7f7c970d.png";